import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocaleService } from '../services/locale/locale.service';
import {
  getHostFromUrl,
  isConfiguredAuthRequest,
} from './stretchit-api-headers/request-classifier';

import { AppConfiguration } from '../services/configuration/app.configuration';

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const localeService = inject(LocaleService);

  return next(addLocaleHeader(req, localeService.currentLocale, inject(AppConfiguration)));
};

function addLocaleHeader(
  req: HttpRequest<unknown>,
  locale: string,
  config: AppConfiguration
): HttpRequest<unknown> {
  if (!getHostFromUrl(req.url).includes('stretchit') && !isConfiguredAuthRequest(req, config))
    return req;
  // Явно проставленный вызывающим язык важнее текущего языка сайта: например, оценка
  // перевода уходит на том языке, на котором смотрели класс, а не на выбранном сейчас
  if (req.headers.has('x-locale')) return req;

  return req.clone({
    headers: req.headers.set('x-locale', locale),
  });
}
